import { useEffect } from 'react';

const MakeDraggable = ({ elementId }) => {
    useEffect(() => {
        let counter = 0;
        let interval = null;

        const initializeDraggable = () => {
            const element = document.getElementById(elementId);
            if (!element) {
                console.error(`Element with id "${elementId}" not found.`);
                return;
            }

            let position = { x: 0, y: 0 };
            let offset = { x: 0, y: 0 };
            let isDragging = false;
            let dragStarted = false; // Tracks if dragging occurred

            const startDrag = (x, y) => {
                window.addEventListener('mousemove', onMouseMove);
                window.addEventListener('touchmove', onTouchMove);
                isDragging = true;
                dragStarted = false; // Reset drag start flag
                offset = {
                    x: x - position.x,
                    y: y - position.y,
                };
                element.style.cursor = 'grabbing';
            };

            const drag = (x, y) => {
                if (!isDragging) return;
                dragStarted = true; // Mark that a drag occurred
                position = {
                    x: x - offset.x,
                    y: y - offset.y,
                };
                element.style.transform = `translate(${position.x}px, ${position.y}px)`;
            };

            const stopDrag = () => {
                isDragging = false;
                element.style.cursor = 'grab';
                window.removeEventListener('mousemove', onMouseMove);
                window.removeEventListener('touchmove', onTouchMove);
            };

            const preventClickOnDrag = e => {
                if (dragStarted) {
                    dragStarted = false;
                    isDragging = false;
                    e.stopPropagation(); // Stop it from bubbling up
                    return false;
                }
            };

            // Mouse events
            const onMouseDown = e => {
                startDrag(e.clientX, e.clientY);
            };

            const onMouseMove = e => {
                drag(e.clientX, e.clientY);
            };

            const onMouseUp = e => {
                stopDrag();
            };

            // Touch events
            const onTouchStart = e => {
                if (e.touches.length === 1) {
                    const touch = e.touches[0];
                    startDrag(touch.clientX, touch.clientY);
                }
            };
            const onTouchMove = e => {
                if (e.touches.length === 1) {
                    const touch = e.touches[0];
                    drag(touch.clientX, touch.clientY);
                }
            };

            const onTouchEnd = () => stopDrag();

            // Click event prevention
            element.addEventListener('click', preventClickOnDrag, { capture: true });

            // Add event listeners
            element.style.position = 'fixed';
            element.style.cursor = 'grab';

            element.addEventListener('mousedown', onMouseDown);
            window.addEventListener('mouseup', onMouseUp);

            element.addEventListener('touchstart', onTouchStart);
            window.addEventListener('touchend', onTouchEnd);

            // Cleanup event listeners
            return () => {
                element.removeEventListener('click', preventClickOnDrag, { capture: true });

                element.removeEventListener('mousedown', onMouseDown);
                window.removeEventListener('mousemove', onMouseMove);
                window.removeEventListener('mouseup', onMouseUp);

                element.removeEventListener('touchstart', onTouchStart);
                window.removeEventListener('touchmove', onTouchMove);
                window.removeEventListener('touchend', onTouchEnd);
            };
        };

        // Delay to ensure the element is loaded
        interval = setInterval(() => {
            counter++;
            if (document.getElementById(elementId)) {
                clearInterval(interval); // Stop polling when the element is found
                interval = null;
                initializeDraggable();
            } else if (counter > 20 && interval) {
                clearInterval(interval);
                interval = null;
            }
        }, 500);

        return () => {
            if (interval) {
                clearInterval(interval);
            }
        };
    }, [elementId]);

    return null;
};

export default MakeDraggable;
